"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const react_native_svg_1 = __importStar(require("react-native-svg"));
const react_i18next_1 = require("react-i18next");
const circularGraphStyles_1 = __importDefault(require("./circularGraphStyles"));
const utils_1 = require("../../utils/utils");
const constants_1 = require("../../constants/constants");
const icon_1 = __importStar(require("../icon/icon"));
const text_1 = __importStar(require("../text/text"));
const styles_1 = __importDefault(require("../../styles/styles"));
const colors_1 = __importDefault(require("../../styles/colors"));
const CircularGraph = ({ activeLoan }) => {
    const outstandingAmount = activeLoan.amount_outstanding ? activeLoan.amount_outstanding : 0;
    const amountPaid = activeLoan.amount_paid ? activeLoan.amount_paid : 0;
    const amountOverdue = activeLoan.amount_overdue ? activeLoan.amount_overdue : 0;
    const { t } = (0, react_i18next_1.useTranslation)();
    const dataServer = [];
    if (outstandingAmount) {
        dataServer.push({
            amount: outstandingAmount,
            label: 'Outstanding amount',
        });
    }
    if (amountPaid) {
        dataServer.push({ amount: amountPaid, label: 'Amount paid' });
    }
    if (amountOverdue) {
        dataServer.push({ amount: amountOverdue, label: 'Amount overdue' });
    }
    const colorsList = [colors_1.default.COLOR_BLUE, colors_1.default.COLOR_BLUE_LIGHT, colors_1.default.COLOR_CRITICAL];
    const radius = 70;
    const circleCircumference = 2 * Math.PI * radius;
    const total = outstandingAmount + amountPaid + amountOverdue;
    const outstandingAmountPercentage = (outstandingAmount / total) * 100;
    const amountPaidPercentage = (amountPaid / total) * 100;
    const amountOverduePercentage = (amountOverdue / total) * 100;
    const outstandingAmountStrokeOffset = circleCircumference - (circleCircumference * outstandingAmountPercentage) / 100;
    const amountPaidStrokeOffset = circleCircumference - (circleCircumference * amountPaidPercentage) / 100;
    const amountOverdueStrokeOffset = circleCircumference - (circleCircumference * amountOverduePercentage) / 100;
    const outstandingAmountAngle = (outstandingAmount / total) * 360;
    const amountPaidAngle = (amountPaid / total) * 360;
    const regularAngle = amountPaidAngle + outstandingAmountAngle;
    const pieData = dataServer.map((element, index) => {
        const data = {
            value: element.amount,
            text: element.label,
            color: colorsList[index],
            percent: element.amount / total,
            strokeOffset: circleCircumference - (circleCircumference * element.amount) / 100,
            angle: (element.amount / total) * 360,
        };
        return data;
    });
    return (react_1.default.createElement(react_native_1.View, { style: circularGraphStyles_1.default.topBarStyle },
        react_1.default.createElement(react_native_1.View, { style: { justifyContent: 'center', alignItems: 'center' } },
            react_1.default.createElement(react_native_1.View, { style: { justifyContent: 'center', alignItems: 'center' } },
                react_1.default.createElement(react_native_svg_1.default, { height: 175, width: 175, viewBox: "0 0 180 180" },
                    react_1.default.createElement(react_native_svg_1.G, { rotation: 90, originX: "90", originY: "90" }, total === 0 ? (react_1.default.createElement(react_native_svg_1.Circle, { cx: "50%", cy: "50%", r: radius, stroke: colors_1.default.COLOR_SECONDARY, fill: "transparent", strokeWidth: "20", strokeLinecap: "round" })) : (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(react_native_svg_1.Circle, { cx: "50%", cy: "50%", r: radius, stroke: colors_1.default.COLOR_SECONDARY, fill: "transparent", strokeWidth: "20", rotation: 0, originX: "90", originY: "90", strokeDasharray: circleCircumference, strokeDashoffset: outstandingAmountStrokeOffset, strokeLinecap: "round" }),
                        react_1.default.createElement(react_native_svg_1.Circle, { cx: "50%", cy: "50%", r: radius, stroke: colors_1.default.COLOR_PRIMARY, fill: "transparent", strokeWidth: "20", rotation: outstandingAmountAngle, originX: "90", originY: "90", strokeDasharray: circleCircumference, strokeDashoffset: amountPaidStrokeOffset, strokeLinecap: "round" }),
                        react_1.default.createElement(react_native_svg_1.Circle, { cx: "50%", cy: "50%", r: radius, stroke: colors_1.default.COLOR_CRITICAL, fill: "transparent", strokeWidth: "20", rotation: regularAngle, originX: "90", originY: "90", strokeDasharray: circleCircumference, strokeDashoffset: amountOverdueStrokeOffset, strokeLinecap: "round" }))))),
                react_1.default.createElement(react_native_1.View, { style: [styles_1.default.centerChildHorizontalVertical, { position: 'absolute' }] },
                    react_1.default.createElement(text_1.default, { titleType: text_1.TEXT_TYPE_SUBTITLE }, t('circularGraph.amount_due')),
                    react_1.default.createElement(text_1.default, { titleType: text_1.TEXT_TYPE_SUBTITLE }, `${constants_1.NAIRA_SYMBOL}${(0, utils_1.formatNumber)(outstandingAmount)}`)))),
        react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexTwo, circularGraphStyles_1.default.amounts] }, pieData.map((element, index) => {
            return (react_1.default.createElement(react_native_1.View, { key: element.text, style: styles_1.default.flexDirectionRow },
                react_1.default.createElement(react_native_1.View, { style: circularGraphStyles_1.default.graphLabelsPosition },
                    react_1.default.createElement(icon_1.default, { name: icon_1.CIRCLE_ICON, fill: colorsList[index] })),
                react_1.default.createElement(react_native_1.View, { style: circularGraphStyles_1.default.amountMargin },
                    react_1.default.createElement(text_1.default, { titleType: text_1.TEXT_TYPE_SUBTITLE, color: colors_1.default.COLOR_GRAY_DARK }, element.text),
                    react_1.default.createElement(text_1.default, { titleType: text_1.TEXT_TYPE_SUBTITLE }, `${constants_1.NAIRA_SYMBOL} ${(0, utils_1.formatNumber)(element.value)}`))));
        }))));
};
exports.default = CircularGraph;
